define('app-ModalComponent/main',['./settings', '../app/ui/dialog'],
    function (settings, dialog) {
        return {
            run: function () {
                var container = $(settings.container);

                if (container.length === 0) {
                    window.log('No Cards found. ModalComponent will not be available.');
                    return;
                }

                $('.componentModalLink').on("click", function (e) {
                    e.preventDefault();
                    var dataToBeSend = {
                        content: $(this).attr('data-content'),
                    };
                    $.ajax({
                        url: "/Modal/GetModalContent",
                        type: "post",
                        data: JSON.stringify(dataToBeSend),
                        dataType: "json",
                        contentType: "application/json",
                        success: function (responseData) {
                            if (responseData.length !== 0) {
                                var contentDiv = $('<div/>');

                                contentDiv.append(responseData);

                                dialog.show('', contentDiv, {
                                    modal: true,
                                    draggable: false,
                                    resizable: false
                                });
                                $('.modal-dialog').addClass('componentModalContent');
                            }
                            else {
                            }
                        },
                        error: function () {
                            alert("Sorry, there is a problem retrieving the data!");
                        }
                    });
                });


                window.loadedModules('app-ModalComponent');
            }
        }
    }
);
